import { render, staticRenderFns } from "./BaseComponentOverviewPage.vue?vue&type=template&id=2670ea78&scoped=true&"
import script from "./BaseComponentOverviewPage.vue?vue&type=script&lang=ts&"
export * from "./BaseComponentOverviewPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2670ea78",
  null
  
)

export default component.exports